import { CUSTOMER_JOURNEY_WEATHER_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_WEATHER_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyWeatherSuccess.js